//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { NameFormat } from './Enums';

export class SchoolUpdateItem extends ItemBase {
    EnableCalendarConflicts?: boolean;
    Locale?: string | null;
    Name?: string | null;
    ParentNameFormat?: NameFormat;
    PhoneNumber?: string | null;
    ShowNotSpecifiedEventLocation?: boolean;
    StudentNameFormat?: NameFormat;
    TeacherNameFormat?: NameFormat;
    TimeZoneID?: string | null;
    CanSetTimeZone?: boolean;
    GoogleReviewsLink?: string | null;

    constructor(initializer?: Partial<SchoolUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolUpdateItem";
}
